/* eslint-disable */


// Programatically generated on Mon Dec 08 2025 22:28:20 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'guesses_v1',
    'attributes': {
      'partial_credit_available': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'eliminated_options': {
        'type': 'map',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'correct': {
        'type': 'boolean',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'time_elapsed': {
        'type': 'integer',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'correctness_context': {
        'type': 'map',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'points_earned': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'answered_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'adaptive_practice_id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'grade': {
        'type': 'float',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'content': {
        'type': 'map',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'attempt_number': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'partial_credit_earned': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'student_v2': {
        'type': 'one-to-one'
      },
      'student_assignment_v1': {
        'type': 'one-to-one'
      },
      'authoring_question_v1': {
        'type': 'one-to-one'
      },
      'assignment_v1': {
        'type': 'one-to-one'
      },
      'assignment_v2': {
        'type': 'one-to-one'
      },
      'assignment_v3': {
        'type': 'one-to-one'
      },
      'authoring_exam_v1': {
        'type': 'one-to-one'
      },
      'question_v1': {
        'type': 'one-to-one'
      },
      'question_v2': {
        'type': 'one-to-one'
      },
      'media_v1': {
        'type': 'one-to-many'
      },
      'question_v3': {
        'type': 'one-to-one'
      },
      'search_question_v1': {
        'type': 'one-to-one'
      },
      'public_question_v1': {
        'type': 'one-to-one'
      },
      'search_question_v2': {
        'type': 'one-to-one'
      },
      'student_v1': {
        'type': 'one-to-one'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'partial_credit_available': Empty,
    'eliminated_options': Empty,
    'media': Empty,
    'question': Empty,
    'authoring_exam': Empty,
    'correct': Empty,
    'time_elapsed': Empty,
    'assignment': Empty,
    'authoring_question': Empty,
    'correctness_context': Empty,
    'student_assignment': Empty,
    'points_earned': Empty,
    'answered_at': Empty,
    'adaptive_practice_id': Empty,
    'updated_at': Empty,
    'grade': Empty,
    'content': Empty,
    'inserted_at': Empty,
    'attempt_number': Empty,
    'id': Empty,
    'student': Empty,
    'public_question': Empty,
    'relationshipMeta': Empty,
    'search_question': Empty,
    'partial_credit_earned': Empty,
    'meta': new Map({
    'is_most_recent_guess': Empty,
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'partial_credit_available': 0,
    'id': '',
    'media': new List(),
    'eliminated_options': new Map(),
    'meta': new Map(),
    'question': new Map(),
    'authoring_exam': new Map(),
    'correct': false,
    'time_elapsed': 0,
    'adaptive_practice_id': '',
    'answered_at': new Date(),
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'assignment': new Map(),
    'authoring_question': new Map(),
    'correctness_context': new Map(),
    'student_assignment': new Map(),
    'points_earned': 0,
    'grade': 0,
    'content': new Map(),
    'attempt_number': 0,
    'student': new Map(),
    'public_question': new Map(),
    'relationshipMeta': new Map(),
    'search_question': new Map(),
    'partial_credit_earned': 0
  }
);

export class GuessModelV1 extends GenericModel(ModelRecord, ModelConfig, 'GuessModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyGuessModelV1Model = _emptyGuessModelV1Model ? _emptyGuessModelV1Model : new GuessModelV1(DefaultModel);
    return _emptyGuessModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'GuessModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'guess_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {binary_id}
   */
  getAdaptivePracticeId() {
    const value = this.getValueForAttribute('adaptive_practice_id');
    return value;
  }

  setAdaptivePracticeId(value) {
    return this.setField('adaptive_practice_id', value);
  }

  /**
   * @type {datetime}
   */
  getAnsweredAt() {
    const value = this.getValueForAttribute('answered_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {integer}
   */
  getAttemptNumber() {
    const value = this.getValueForAttribute('attempt_number');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {map}
   */
  getContent() {
    const value = this.getValueForAttribute('content');
    return value;
  }

  setContent(value) {
    return this.setField('content', value);
  }

  /**
   * @type {boolean}
   */
  isCorrect() {
    const value = this.getValueForAttribute('correct');
    return value;
  }

  /**
   * @type {map}
   */
  getCorrectnessContext() {
    const value = this.getValueForAttribute('correctness_context');
    return value;
  }

  /**
   * @type {map}
   */
  getEliminatedOptions() {
    const value = this.getValueForAttribute('eliminated_options');
    return value;
  }

  setEliminatedOptions(value) {
    return this.setField('eliminated_options', value);
  }

  /**
   * @type {float}
   */
  getGrade() {
    const value = this.getValueForAttribute('grade');
    
      const float = parseFloat(value, 10);
      return isNaN(float) ? value : float;
    
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {integer}
   */
  getPartialCreditAvailable() {
    const value = this.getValueForAttribute('partial_credit_available');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {integer}
   */
  getPartialCreditEarned() {
    const value = this.getValueForAttribute('partial_credit_earned');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {integer}
   */
  getPointsEarned() {
    const value = this.getValueForAttribute('points_earned');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {integer}
   */
  getTimeElapsed() {
    const value = this.getValueForAttribute('time_elapsed');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setTimeElapsed(value) {
    return this.setField('time_elapsed', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      isMostRecentGuess() {
        return this.getMeta().isMostRecentGuess();
      }
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {boolean}
           */
          isMostRecentGuess() {
            const value = meta.get('is_most_recent_guess');
            validate(value, 'is_most_recent_guess');
            return value;
          },
  
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {media_v1 (many)}
   */
  getMedia() {
    const value = this.getValueForAttribute('media');
    return value;
  }

  // -- Relationship Fields: media --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {question_v3 (one)}
   */
  getQuestion() {
    const value = this.getValueForAttribute('question');
    return value;
  }

  // -- Relationship Fields: question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_exam_v1 (one)}
   */
  getAuthoringExam() {
    const value = this.getValueForAttribute('authoring_exam');
    return value;
  }

  // -- Relationship Fields: authoring_exam --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {assignment_v3 (one)}
   */
  getAssignment() {
    const value = this.getValueForAttribute('assignment');
    return value;
  }

  // -- Relationship Fields: assignment --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_question_v1 (one)}
   */
  getAuthoringQuestion() {
    const value = this.getValueForAttribute('authoring_question');
    return value;
  }

  // -- Relationship Fields: authoring_question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {student_assignment_v1 (one)}
   */
  getStudentAssignment() {
    const value = this.getValueForAttribute('student_assignment');
    return value;
  }

  // -- Relationship Fields: student_assignment --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {student_v2 (one)}
   */
  getStudent() {
    const value = this.getValueForAttribute('student');
    return value;
  }

  // -- Relationship Fields: student --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {public_question_v1 (one)}
   */
  getPublicQuestion() {
    const value = this.getValueForAttribute('public_question');
    return value;
  }

  // -- Relationship Fields: public_question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {search_question_v2 (one)}
   */
  getSearchQuestion() {
    const value = this.getValueForAttribute('search_question');
    return value;
  }

  // -- Relationship Fields: search_question --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptyGuessModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'adaptive_practice_id': null,
  'answered_at': null,
  'attempt_number': null,
  'correct': null,
  'grade': null,
  'id': null,
  'inserted_at': null,
  'meta.is_most_recent_guess': null,
  'partial_credit_available': null,
  'partial_credit_earned': null,
  'points_earned': null,
  'time_elapsed': null,
  'updated_at': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'adaptive_practice_id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'answered_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'assignment_v1': new Set(['associated']),
  'assignment_v2': new Set(['associated']),
  'assignment_v3': new Set(['associated']),
  'attempt_number': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'authoring_exam_v1': new Set(['associated']),
  'authoring_question_v1': new Set(['associated']),
  'content': new Set(['null']),
  'correct': new Set(['exact','not','null']),
  'correctness_context': new Set(['null']),
  'eliminated_options': new Set(['null']),
  'grade': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'media_v1': new Set(['associated']),
  'meta.is_most_recent_guess': new Set(['exact','not','null']),
  'meta.populated_metadata_fields': new Set(['null']),
  'partial_credit_available': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'partial_credit_earned': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'points_earned': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'public_question_v1': new Set(['associated']),
  'question_v1': new Set(['associated']),
  'question_v2': new Set(['associated']),
  'question_v3': new Set(['associated']),
  'search_question_v1': new Set(['associated']),
  'search_question_v2': new Set(['associated']),
  'student_assignment_v1': new Set(['associated']),
  'student_v1': new Set(['associated']),
  'student_v2': new Set(['associated']),
  'time_elapsed': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
    'end_date': 'meta.context.end_date',
    'most_recent': 'meta.context.guess.most_recent',
    'start_date': 'meta.context.start_date',
  },
  required: {
  }
});

// -- Legacy Name Export --
export const Guess = GuessModelV1;
